import React from 'react';

import classes from '../installPics.css';

import Photo from '../../../../../../../assets/AX320.jpg';

const Image = () => (
    <div className={classes.installImages}>
        <img alt="Axitec 320W All Black " src={Photo} className={classes.installImg} />
    </div>
);


export default Image;



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/SalesLogic/InstallImages/Modules/AX320.js